/* eslint-disable prefer-template */
import { logger } from '@sendpayments/js-utils';
import { get } from 'lodash';
import reducers from './reducers';

const reducer = (state, action) => {
  const { type } = action;

  if (!type) {
    logger.error('@sendpayments/react-shared/remote-data', `type need to be present`, action);
  }

  const entityType = get(action, 'payload.entity.type');
  const entityId = get(action, 'payload.entity.id');

  logger.log(
    '@sendpayments/react-shared/remote-data',
    `reducer executing action type ${type}. ${entityType ? 'Entity Types:' + entityType : ''} ${
      entityId ? 'Entity Id:' + entityId : ''
    }`,
    action,
  );

  if (reducers[type]) {
    const reduce = reducers[type];
    return reduce(state, action);
  }

  logger.error('@sendpayments/react-shared/remote-data', `reducer unknown action. we are skipping it`, action);

  // this is the default case
  return state;
};
export default reducer;
